/** Mirrors the storefront's `enum WorkflowStepStatus`. */
export enum WorkflowStepStatus {
  WAITING = 'WAITING',
  COMPLETED = 'COMPLETED',
  EXPIRED = 'EXPIRED',
  TRIGGER_FAILED = 'TRIGGER_FAILED',
}

export interface IWorkflowStepRequestVariables {
  storefrontName: string
  sessionUid: string
  requestId: string
}

export interface IWorkflowStepRequestState {
  requestId: string
  status: WorkflowStepStatus
  /** The outcome name the step called back with; `null` until `COMPLETED`. */
  outcome: string | null
  /** What the step called back with; `null` until `COMPLETED`, or if none. */
  data: Record<string, unknown> | null
  /** ISO 8601. */
  expiresAt: string
}

/**
 * `null` is reachable because the schema declares the field nullable; a miss
 * arrives as a `404` on the error path, not as `null`.
 */
export interface IWorkflowStepRequestResponse {
  workflowStepRequest: IWorkflowStepRequestState | null
}
